
import React from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentMeeting } from '../store/slices/meetingsSlice';
import { skipToken } from '@reduxjs/toolkit/query';
import { useGetPdfDataQuery } from '../api/PDFApi';
import { jsPDF } from 'jspdf';
import AlefNormal from './AlefFont';
import ImgMekimi from './ImgMekimi';

const PdfDownloader: React.FC = () => {
  const currentMeeting = useSelector(selectCurrentMeeting);
  const meetingId = currentMeeting?.id;
  const familyId = currentMeeting?.family_id;

  const { data, isLoading, error } = useGetPdfDataQuery(
    meetingId && familyId ? { meetingId, familyId } : skipToken
  );

  const rtl = (text: string) => text.split('').reverse().join('');

  const handleDownload = () => {
  if (!data) return;

  const doc = new jsPDF();
  doc.addFileToVFS('Alef-Regular.ttf', AlefNormal);
  doc.addFont('Alef-Regular.ttf', 'Alef', 'normal');
  doc.setFont('Alef');
  doc.setFontSize(14);

doc.addImage(ImgMekimi, 'PNG', 160, 10, 30, 30);

  let y = 20;

  doc.setFontSize(18);
  doc.text(rtl('דו"ח פגישה'), 105, y, { align: 'center' });
  y += 10;
  doc.setFontSize(14);
  doc.line(20, y, 190, y);
  y += 10;

  const addLine = (label: string, value: string | number) => {
    doc.text(rtl(`${label} ${value}`), 180, y, { align: 'right' });
    y += 10;
  };

  addLine('מספר פגישה:', data.meeting.meeting_number);
  addLine('תאריך:', new Date(data.meeting.date).toLocaleDateString('he-IL'));
  addLine('מיקום:', data.meeting.location);

  data.meeting.attendees.forEach((attendee: string) => {
    addLine('נוכח:', attendee);
  });

  y += 5;
  doc.setFontSize(16);
  doc.text(rtl('נתונים פיננסיים'), 180, y, { align: 'right' });
  y += 5;
  doc.line(120, y, 190, y); 
  y += 10;
  doc.setFontSize(14);

  addLine('סך הכנסות:', data.financialData.total_income);
  addLine('סך הוצאות:', data.financialData.total_expenses);
  addLine('יתרה:', data.financialData.income_expense_difference);
  addLine('חוב נוכחי:', data.financialData.current_debt_amount);
  addLine('החזר חד פעמי:', data.financialData.one_time_debt_repayment);
  addLine('החזר חודשי:', data.financialData.monthly_debt_repayment);

  if (data.tasks && data.tasks.length > 0) {
    y += 10;
    doc.setFontSize(16);
    doc.text(rtl('משימות'), 180, y, { align: 'right' });
    y += 5;
    doc.line(120, y, 190, y); 
    y += 10;
    doc.setFontSize(12);

    const tableHeaders = ['#', 'תיאור', 'סטטוס', 'הערות'];
    const columnWidths = [10, 60, 40, 60];
    const startX = 200;
    let currentY = y;

    const drawRow = (rowData: string[], rowY: number) => {
      let x = startX;
      rowData.forEach((cell, index) => {
        const cellWidth = columnWidths[index];
        x -= cellWidth;
        doc.text(rtl(cell), x + cellWidth - 2, rowY, { align: 'right' });
        doc.rect(x, rowY - 5, cellWidth, 10); 
      });
    };

    drawRow(tableHeaders, currentY);
    currentY += 12;

    data.tasks.forEach((task, index) => {
      const row = [
        (index + 1).toString(),
        task.description || 'אין',
        task.status || 'אין',
        task.comments || 'אין',
      ];
      drawRow(row, currentY);
      currentY += 12;

      if (currentY > 270) {
        doc.addPage();
        currentY = 20;
      }
    });

    y = currentY;
  }

  doc.save(`meeting-${meetingId}.pdf`);
};


  if (isLoading) return <div>טוען נתונים...</div>;
  if (error) return <div>שגיאה בטעינה</div>;

  return (
      <button
        onClick={handleDownload}
        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
      >
        הורד PDF
      </button>
  );
};

export default PdfDownloader;
